import { TenantEntity } from '../TenantEntity'
import { DataSyncBase } from '@/class/model/DataSyncBase'

export class PriceRegion extends DataSyncBase {
  constructor(data) {
    super(data)
    this.className = 'PriceRegion'
  }

  get priceUuid() {
    return this._data.priceUuid
  }

  set priceUuid(priceUuid) {
    this._data.priceUuid = priceUuid || ''
  }

  get country() {
    return this._data.country
  }

  set country(country) {
    this._data.country = country || 'CN'
  }

  get province() {
    return this._data.province
  }

  set province(province) {
    this._data.province = province || ''
  }

  get city() {
    return this._data.city
  }

  set city(city) {
    this._data.city = city || ''
  }

  get districts() {
    return this._data.districts
  }

  set districts(districts) {
    this._data.districts = districts || ''
  }

  get townUuid() {
    return this._data.townUuid
  }

  set townUuid(townUuid) {
    this._data.townUuid = townUuid || ''
  }

  get detailAddress() {
    return this._data.detailAddress
  }

  set detailAddress(detailAddress) {
    this._data.detailAddress = detailAddress || ''
  }

  get deliveryAddressType() {
    return this._data.deliveryAddressType
  }

  set deliveryAddressType(deliveryAddressType) {
    this._data.deliveryAddressType = deliveryAddressType || 1
  }

  get postalCode() {
    return this._data.postalCode
  }

  set postalCode(postalCode) {
    this._data.postalCode = postalCode || ''
  }

  get address() {
    return this._data.address
  }

  set address(address) {
    this._data.address = address || ''
  }

  get warehouseCode() {
    return this._data.warehouseCode
  }

  set warehouseCode(warehouseCode) {
    this._data.warehouseCode = warehouseCode || ''
  }
}
